
import { z } from "zod";

export const AblyConnectionStateValues = ["initialized", "connecting", "connected", "disconnected", "suspended", "closing", "closed", "failed"] as const;
export const AblyConnectionStateSchema = z.enum(AblyConnectionStateValues);
export const AblyConnectionState = AblyConnectionStateSchema.enum;
export type AblyConnectionState = (typeof AblyConnectionStateValues)[number];
